import { render, staticRenderFns } from "./addBill.vue?vue&type=template&id=7c236058&scoped=true"
import script from "./addBill.vue?vue&type=script&lang=js"
export * from "./addBill.vue?vue&type=script&lang=js"
import style0 from "./addBill.vue?vue&type=style&index=0&id=7c236058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c236058",
  null
  
)

export default component.exports